// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stick_follow_icon {
    top: 50%;
    left: 30px;
    width: 20px;
    height: 200px;
    position: fixed;
    margin-top: -100px;
}

.stick_follow_icon ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.stick_follow_icon svg {
    width: 1.3em;
    height: 1.3em;
    fill: var(--text-color)
}

.stick_follow_icon p {
    top: 70px;
    left: -24px;
    width: 68px;
    height: 20px;
    color: var(--text-color);
    font-size: 18px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    position: relative;
    transform: rotate( -90deg);
}

.stick_follow_icon ul li {
    display: block;
    font-size: 18px;
    text-align: center;
    margin-bottom: 10px;
    transition: all .3s;
}

.stick_follow_icon p:after {
    top: 9px;
    right: -48px;
    width: 40px;
    height: 1px;
    content: "";
    display: block;
    position: absolute;
    background-color: var(--text-color);
}

@media only screen and (max-width: 991px) {
    .stick_follow_icon {
        width: unset;
        height: unset;
        position: static;
        margin-top: unset;
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        padding: 40px 0;
        align-items: center;
    }
    .stick_follow_icon p {
        top: unset;
        left: unset;
        width: unset;
        height: unset;
        white-space: nowrap;
        position: relative;
        transform: unset;
        font-size: 24px;
        margin-right: 65px;
    }
    .stick_follow_icon ul {
        margin-bottom: 20px;
    }
    .stick_follow_icon ul li {
        display: inline;
        margin-bottom: 29px;
        margin-right: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/socialicons/style.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,UAAU;IACV,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;QACb,2BAA2B;QAC3B,uBAAuB;QACvB,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mBAAmB;QACnB,kBAAkB;IACtB;AACJ","sourcesContent":[".stick_follow_icon {\n    top: 50%;\n    left: 30px;\n    width: 20px;\n    height: 200px;\n    position: fixed;\n    margin-top: -100px;\n}\n\n.stick_follow_icon ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.stick_follow_icon svg {\n    width: 1.3em;\n    height: 1.3em;\n    fill: var(--text-color)\n}\n\n.stick_follow_icon p {\n    top: 70px;\n    left: -24px;\n    width: 68px;\n    height: 20px;\n    color: var(--text-color);\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.2;\n    white-space: nowrap;\n    position: relative;\n    transform: rotate( -90deg);\n}\n\n.stick_follow_icon ul li {\n    display: block;\n    font-size: 18px;\n    text-align: center;\n    margin-bottom: 10px;\n    transition: all .3s;\n}\n\n.stick_follow_icon p:after {\n    top: 9px;\n    right: -48px;\n    width: 40px;\n    height: 1px;\n    content: \"\";\n    display: block;\n    position: absolute;\n    background-color: var(--text-color);\n}\n\n@media only screen and (max-width: 991px) {\n    .stick_follow_icon {\n        width: unset;\n        height: unset;\n        position: static;\n        margin-top: unset;\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: center;\n        padding: 40px 0;\n        align-items: center;\n    }\n    .stick_follow_icon p {\n        top: unset;\n        left: unset;\n        width: unset;\n        height: unset;\n        white-space: nowrap;\n        position: relative;\n        transform: unset;\n        font-size: 24px;\n        margin-right: 65px;\n    }\n    .stick_follow_icon ul {\n        margin-bottom: 20px;\n    }\n    .stick_follow_icon ul li {\n        display: inline;\n        margin-bottom: 29px;\n        margin-right: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
